import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./title-and-subtitle-component.scss";
class TitleAndSubtitleComponent extends PureComponent {
    render() {
        const { title, subtitle, textColor, paddingBottom } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            style: {
                paddingBottom: `${paddingBottom}`
            },
            className: `jsx-${componentStyles.__hash}` + " " + "title-and-subtitle-component",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + (classnames("title-and-subtitle-content", {
                        "white-text": textColor === "white"
                    }) || ""),
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: `jsx-${componentStyles.__hash}` + " " + "title",
                            children: title
                        }),
                        subtitle && /*#__PURE__*/ _jsx("h2", {
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            },
                            className: `jsx-${componentStyles.__hash}` + " " + "subtitle"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { TitleAndSubtitleComponent as default };
TitleAndSubtitleComponent.defaultProps = {
    title: "",
    subtitle: "",
    textColor: "",
    paddingBottom: 0
};
